import { createHttpService } from '../ApiService';
import { IAttendanceDashboardData } from './dashboardAttendance.interfaces';
import { ICommunicationDashboardData } from './dashboardCommunications.interfaces';
import {
  IFinanceDashboardData,
  IPeopleDashboardData,
  IEventsDashboardData,
  ITimeRangeParams,
} from './dashboard.interfaces';
// Legacy interfaces (still used by context)
import { IEventsDashboardData as ILegacyEventsDashboardData } from './dashboardEvents.interfaces';
import { IHealthDashboardData } from './dashboardHealth.interfaces';
import { IInventoryDashboardData } from './dashboardInventory.interfaces';
import { IStaffDashboardData } from './dashboardStaff.interfaces';
import { IStudentsDashboardData } from './dashboardStudents.interfaces';
import { dashboardAttendanceMock } from 'src/__mocks__/dashboard/dashboardAttendance.mock';
import { dashboardCommunicationsMock } from 'src/__mocks__/dashboard/dashboardCommunications.mock';
import { dashboardEventsMock } from 'src/__mocks__/dashboard/dashboardEvents.mock';
import { dashboardHealthMock } from 'src/__mocks__/dashboard/dashboardHealth.mock';
import { dashboardInventoryMock } from 'src/__mocks__/dashboard/dashboardInventory.mock';
import { dashboardStaffMock } from 'src/__mocks__/dashboard/dashboardStaff.mock';
import { dashboardStudentsMock } from 'src/__mocks__/dashboard/dashboardStudents.mock';
import { financeDashboardNewMock } from 'src/__mocks__/dashboard/dashboardFinanceNew.mock';
import { peopleDashboardNewMock } from 'src/__mocks__/dashboard/dashboardPeopleNew.mock';
import { eventsDashboardNewMock } from 'src/__mocks__/dashboard/dashboardEventsNew.mock';

export const useDashboardService = () => {
  const httpAPI = createHttpService();
  const baseDashboardPath = '/dashboard';
  // TODO: Naman - build APIs for dashboard and remove mock data
  const isMockData = true; // process.env.REACT_APP_WITH_MOCK === 'true';

  // New API methods with time range support
  const getFinanceDashboardData = (params?: ITimeRangeParams) => {
    if (isMockData) {
      return Promise.resolve(financeDashboardNewMock);
    }
    return httpAPI.get<IFinanceDashboardData>(`${baseDashboardPath}/finance`, {
      params,
    });
  };

  const getPeopleDashboardData = (params?: ITimeRangeParams) => {
    if (isMockData) {
      return Promise.resolve(peopleDashboardNewMock);
    }
    return httpAPI.get<IPeopleDashboardData>(`${baseDashboardPath}/people`, {
      params,
    });
  };

  const getEventsDashboardDataNew = (params?: ITimeRangeParams) => {
    if (isMockData) {
      return Promise.resolve(eventsDashboardNewMock);
    }
    return httpAPI.get<IEventsDashboardData>(`${baseDashboardPath}/events`, {
      params,
    });
  };

  const getAttendanceDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardAttendanceMock);
    }
    return httpAPI.get<IAttendanceDashboardData>(
      `${baseDashboardPath}/attendance`
    );
  };

  const getInventoryDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardInventoryMock);
    }
    return httpAPI.get<IInventoryDashboardData>(
      `${baseDashboardPath}/inventory`
    );
  };

  const getHealthDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardHealthMock);
    }
    return httpAPI.get<IHealthDashboardData>(`${baseDashboardPath}/health`);
  };

  const getCommunicationDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardCommunicationsMock);
    }
    return httpAPI.get<ICommunicationDashboardData>(
      `${baseDashboardPath}/communication`
    );
  };

  const getEventsDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardEventsMock);
    }
    return httpAPI.get<ILegacyEventsDashboardData>(`${baseDashboardPath}/events`);
  };

  const getStaffDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardStaffMock);
    }
    return httpAPI.get<IStaffDashboardData>(`${baseDashboardPath}/staff`);
  };

  const getStudentDashboardData = () => {
    if (isMockData) {
      return Promise.resolve(dashboardStudentsMock);
    }
    return httpAPI.get<IStudentsDashboardData>(`${baseDashboardPath}/student`);
  };

  return {
    // New methods with time range support
    getFinanceDashboardData,
    getPeopleDashboardData,
    getEventsDashboardDataNew,
    // Legacy methods (still used by context and hooks)
    getAttendanceDashboardData,
    getInventoryDashboardData,
    getHealthDashboardData,
    getCommunicationDashboardData,
    getEventsDashboardData,
    getStaffDashboardData,
    getStudentDashboardData,
  };
};
